<template>
	<div class="mail-sign-up-container">
		<img src="@/assets/sign-up/mail.png" class="mail-img" />
		<h1>{{ $t('onboarding_mobile.title') }}</h1>
		<p class="subtitle">{{ $t('onboarding_mobile.subtitle') }}</p>
		<div class="info-container">
			<p>
				<span class="number-container">1</span>
				<span class="info-text">
					{{ $t('onboarding_mobile.email_sent') }}
				</span>
			</p>
			<p>
				<span class="number-container">2</span>
				<span class="info-text">
					{{ $t('onboarding_mobile.go_to_desktop') }}
				</span>
			</p>
		</div>
		<DsButtonPrimary class="btn" @click="goToWebsite">
			{{ $t('onboarding_mobile.back_website') }}
		</DsButtonPrimary>
	</div>
</template>

<script>
export default {
	name: 'MobileEmailSignUp',

	methods: {
		goToWebsite() {
			window.location = 'https://loyoly.io'
		},
	},
}
</script>

<style scoped>
h1 {
	color: #000000;
	margin: 0 0 15px;
	font-weight: 700;
	font-size: 26px;
	line-height: 32px;
	text-align: center;
}

.subtitle {
	font-weight: 400;
	font-size: 14px;
	line-height: 17px;
	color: #000000;
	text-align: center;
}

.mail-sign-up-container {
	display: flex;
	flex-direction: column;
	background: #fbfbfb;
	padding-top: 30px;
	margin-left: auto;
}
.mail-img {
	margin: 0px auto 20px auto;
}

.info-container {
	margin-top: 20px;
	gap: 30px;
}

.info-container > p {
	display: flex;
	align-items: center;
}
.number-container {
	border-radius: 50%;
	background-color: var(--primary-button-bg);
	color: white;
	padding: 4.5px 10px;
	margin-right: 10px;
}

.info-text {
	font-weight: 600;
	font-size: 14px;
	line-height: 17px;
}
.btn {
	margin-top: 30px;
}
</style>
